import $ from 'jquery';

$('.ct-about-event-tabs').find($('.tab')).on('click', function () {
    const $allTabs = $('.ct-about-event-tabs').children();

    const tab = $(this).data('tab');

    $('.ct-about-event-content').find($('.active')).removeClass('active');
    $('.ct-about-event-content').find($(`.${tab}`)).addClass('active');

    $('.ct-about-event-image.active').removeClass('active');
    $(`.ct-about-event-image.${tab}`).addClass('active');


    $allTabs.removeClass('active');
    $(this).addClass('active');
})